module.exports = __webpack_public_path__ + "assets1783936157458/img/safe.a326bdc8.svg";